export default "__VITE_ASSET__ChEIi3tT__"